import React from 'react';
import PageList from '../../components/pages/PageList';

const Pages: React.FC = () => {

    return (<div>
        <PageList />
    </div>)
};

export default Pages;